export class FormatUtil {
	/**
	 * Removes line breaks
	 * Replaces multiple whitespaces with one whitespace
	 * Removes remaining whitespace before '<' and after '>'
	 * Removes leading and trailing whitespace
	 * from string
	 * @param str - string with unwanted whitespaces
	 */
	static stripWhitespace(str: string) {
		if (!str?.length) {
			return str;
		}

		return str
			.replaceAll(/\r?\n?/g, '')
			.replaceAll(/\s+/g, ' ')
			.replaceAll(/>\s/g, '>')
			.replaceAll(/\s</g, '<')
			.trim();
	}
}
